import React, { useContext, useEffect, useState } from "react";
import AttendanceTableView from "./attendance-table.view";
import { IAttendanceTable, IAttendanceTableState } from "../attendance.types";
import useAttendanceData from "../../../custom_hooks/useAttendanceData";
import Locale from "../../../core/locale/locale";
import dayjs from 'dayjs';
import "../../../styles/component/attendance-table.scss";
import AttendanceSearchContext from "../AttendanceContext";


const AttendanceTable: React.FC<IAttendanceTable> = (props) => {

    const {fetchAttendanceData, attendanceList, isLoading} = useAttendanceData(props.fetchAttendanceApi);
    const {statusValue}=useContext(AttendanceSearchContext);

    const [state, setState] = useState<IAttendanceTableState>({
        employeeId: '',
        pagination: {
            pageNumber: 0,
            pageSize: 10
        },
        dateFilter: {
            startDate: dayjs().format(Locale.dateFormat),
            endDate: dayjs().format(Locale.dateFormat),
            type: ''
        },
        sorting: {
            sortDirection: 'ASC',
            sortField: 'EMPLOYEE_FIRST_NAME'
        }
    });

    useEffect(() => {
        fetchAttendanceData(state.pagination.pageNumber,
            state.pagination.pageSize,
            state.dateFilter.startDate,
            state.dateFilter.endDate,
            state.employeeId,
            state.sorting.sortField,
            state.sorting.sortDirection,
            statusValue);
    }, [statusValue]);



    function handleDateChange(range: { startDate: string, endDate: string, type: string }) {
        let pageNum = state.pagination.pageNumber;
        if (state.dateFilter.type !== range.type) {
            pageNum = 0;
            setState((prev) => ({
                ...prev,
                pagination: {...prev.pagination, pageNumber: 0}
            }));
        }
        const pageSize = state.pagination.pageSize;
        const startDate = range.startDate;
        const endDate = range.endDate;

        setState((prev) => ({
            ...prev,
            dateFilter: {
                startDate: startDate,
                endDate: endDate,
                type: range.type
            }
        }));

        fetchAttendanceData(
            pageNum,
            pageSize,
            startDate,
            endDate,
            state.employeeId,
            state.sorting.sortField,
            state.sorting.sortDirection,
            statusValue
        );
    }

    const handleSortChange = (field: string, direction: "ASC" | "DESC") => {

        fetchAttendanceData(
            0,
            state.pagination.pageSize,
            state.dateFilter.startDate,
            state.dateFilter.endDate,
            state.employeeId,
            field,
            direction,
            statusValue
        );

        setState((prev) => ({
            ...prev,
            sorting: {
                sortField: field,
                sortDirection: direction,
            },
            pagination: {
                ...prev.pagination,
                pageNumber: 0
            }
        }));

    };

    function handlePrevPage() {
        if (state.pagination.pageNumber > 0) {
            const prevPage = state.pagination.pageNumber - 1;

            setState((prev) => ({
                ...prev,
                pagination: {
                    ...prev.pagination,
                    pageNumber: prevPage
                }
            }));

            fetchAttendanceData(prevPage, state.pagination.pageSize,
                state.dateFilter.startDate,
                state.dateFilter.endDate,
                state.employeeId,
                state.sorting.sortField,
                state.sorting.sortDirection,
                statusValue
            );
        }
    }

    function handleNextPage() {
        const nextPage = state.pagination.pageNumber + 1;

        setState((prev) => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                pageNumber: nextPage
            }
        }));

        fetchAttendanceData(nextPage,
            state.pagination.pageSize,
            state.dateFilter.startDate,
            state.dateFilter.endDate,
            state.employeeId,
            state.sorting.sortField,
            state.sorting.sortDirection,
            statusValue
        );
    }

    function handleEmployeeId(id: string) {
        setState((prev) => ({
            ...prev,
            employeeId: id,
            pagination: {
                ...prev.pagination,
                pageNumber: 0,
                pageSize: 10
            }
        }));
        fetchAttendanceData(state.pagination.pageNumber,
            state.pagination.pageSize,
            state.dateFilter.startDate,
            state.dateFilter.endDate,
            id,
            state.sorting.sortField,
            state.sorting.sortDirection,
        );
    }

    return (
        <AttendanceTableView
            supervisorId={props.supervisorId}
            title={props.title}
            showPunchOnClick={props.showPunchOnClick}
            isActionVisible={props.isActionVisible}
            loading={isLoading}
            employeeId={state.employeeId}
            list={attendanceList}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            handleSortChange={handleSortChange}
            pageNumber={state.pagination.pageNumber}
            pageSize={state.pagination.pageSize}
            handleDateChange={handleDateChange}
            handleEmployeeId={handleEmployeeId}
            sortField={state.sorting.sortField}
            sortDirection={state.sorting.sortDirection}
        />
    );
};

export default AttendanceTable;

